import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { GlobalTax } from '../../../models/global-tax';

import { NotyService } from '../../../services/common/noty.service';
import { GlobalTaxService } from '../../../services/accounting/global-tax.service';
import { UserService } from '../../../services/users/user.service';

declare var swal: any;

@Component({
  selector: 'app-global-tax-form',
  templateUrl: './global-tax-form.component.html',
  styleUrls: ['./global-tax-form.component.scss'],
})
export class GlobalTaxFormComponent implements OnInit {
  formOptions: any = {
    frequencies: [],
    ways: [],
  };

  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  globalTax: GlobalTax = new GlobalTax();

  constructor(private route: ActivatedRoute, private location: Location, private notyService: NotyService, private router: Router, private globalTaxService: GlobalTaxService, private userService: UserService) {}

  // Component lifecycle events
  ngOnInit() {
    this.userService.navbarComponent.setTaxesMenu();
    this.globalTaxService.formOptions().then((formOptions) => {
      if (formOptions) this.formOptions = formOptions;
      if (this.route.snapshot.params['id'])
        this.globalTaxService.edit(Number(this.route.snapshot.params['id'])).then((globalTax) => {
          this.globalTax = globalTax;
        });
      else {
        this.globalTax.frequency = this.formOptions.frequencies[0].value;
        this.globalTax.way = this.formOptions.ways[0].value;
      }
    });
  }

  // Component methods
  back() {
    this.location.back();
  }

  delete() {
    swal({
      title: 'Delete Global Tax ?',
      text: `Delete global tax - ${this.globalTax.name}`,
      icon: 'warning',
      className: 'swal-btn-center',
      buttons: {
        b1: {
          text: 'Cancel',
          value: 'cancel',
          className: 'btn btn-outline-secondary btn-sm',
        },
        b2: {
          text: 'Confirm',
          value: 'confirm',
          className: 'btn btn-danger btn-sm',
        },
      },
    })
      .then((value: any) => {
        if (value == 'confirm') {
          let noty: any = this.notyService.modalNotify('Deleting <i class="fas fa-spinner fa-fw fa-pulse"></i>', 'warning', false);
          this.globalTaxService
            .delete(this.globalTax.id)
            .then((response_json) => {
              noty.close();
              if (response_json.success) {
                this.notyService.notify(response_json.text || 'Global Tax deleted', 'warning');
                this.router.navigateByUrl('/global_taxes');
              } else this.notyService.notify(response_json.text || 'Error deleting Global Tax', 'error');
            })
            .catch(() => {
              noty.close();
              this.notyService.notify('Error deleting Global Tax', 'error');
            });
        }
      })
      .catch((err: any) => {});
  }

  save(formValid: boolean) {
    this.formSubmitted = true;
    if (!formValid) return;
    this.formSubmitting = true;
    this.globalTaxService
      .save(this.globalTax)
      .then((response_json) => {
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Global Tax saved successfully', 'success');
          this.router.navigateByUrl('/global_taxes');
        } else this.notyService.notify(response_json.text || 'Error saving global tax', 'error');
      })
      .catch(() => {
        this.formSubmitting = false;
        this.notyService.notify('Error saving global tax', 'error');
      });
  }
}
